import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "eGeeTouch® is an NFC+Bluetooth luggage lock embedded with intelligent proximity access technology provides incredibly hassle free experience and high security for safeguarding your personal belongings in a suitcase. You need no key, no dialling tiny digit-wheels, no worry on forgetting combination code for unlocking or concern over your 3-digit code is easily cracked! Simply tap an accompanied NFC tag or a paired your mobile device (Android & iOS smartphones) with eGeeTouch App to unlock and track you luggage in vicinity. It has a built-in smart microchip tag for luggage identification that replaces traditional leather tags.",
    reply2:
      "eGeeTouch® smart padlock traces WHO, WHEN & WHERE an access was made (patented feature) providing an audit trail/log - a security-relevant chronological record, containing documentary evidence of the sequence of access history which is a useful feature unmatched by any conventional padlock.",
    more: "Learn more",
    back: "Back",
  },
  ja: {
    reply1:
      "eGeeTouch® は、インテリジェントな近接アクセス技術が組み込まれた NFC+Bluetooth 荷物ロックで、驚くほど手間のかからないエクスペリエンスと、スーツケース内の個人の持ち物を保護するための高いセキュリティを提供します。キーも必要なく、小さな数字ホイールをダイヤルする必要もなく、ロックを解除するための組み合わせコードを忘れたり、3 桁のコードが簡単に解読される心配もありません。付属の NFC タグ、または eGeeTouch アプリとペアリングされたモバイル デバイス (Android および iOS スマートフォン) をタップするだけで、近くにある荷物のロックを解除して追跡できます。従来のレザータグに代わる、荷物識別用のスマートマイクロチップタグが内蔵されています。",
    reply2:
      "eGeeTouch® スマート南京錠は、誰が、いつ、どこでアクセスしたかを追跡し (特許取得済みの機能)、監査証跡/ログ (一連のアクセス履歴の文書証拠を含むセキュリティ関連の時系列記録) を提供します。これは従来のどの機能にも匹敵しない便利な機能です南京錠。",
    more: "もっと詳しく知る",
    back: "戻る",
  },
  es: {
    reply1:
      "eGeeTouch® es un candado para equipaje NFC+Bluetooth integrado con tecnología de acceso por proximidad inteligente que proporciona una experiencia increíblemente sencilla y alta seguridad para proteger sus pertenencias personales en una maleta. ¡No necesita llave, ni marcar pequeñas ruedas de dígitos, ni preocuparse por olvidar el código de combinación para desbloquear o preocuparse porque su código de 3 dígitos se descifra fácilmente! Simplemente toque una etiqueta NFC adjunta o vincule su dispositivo móvil (teléfonos inteligentes Android e iOS) con la aplicación eGeeTouch para desbloquear y rastrear su equipaje en las cercanías. Tiene una etiqueta con microchip inteligente incorporada para la identificación del equipaje que reemplaza las etiquetas de cuero tradicionales.",
    reply2:
      "El candado inteligente eGeeTouch® rastrea QUIÉN, CUÁNDO Y DÓNDE se realizó un acceso (función patentada) proporcionando un registro/pista de auditoría: un registro cronológico relevante para la seguridad, que contiene evidencia documental de la secuencia del historial de acceso, que es una característica útil que no tiene comparación con ningún sistema convencional candado.",
    more: "Más información",
    back: "Atrás",
  },
});

class Q1_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "Q2", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "Q2",
          trigger: "Q2",
        });
      });
    }
  };

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "Q2" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick}
            disabled={clicked}
          >
            {localizationStrings.more}
          </button>
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q1_component;
